"use client";

import { PublicAuthProvider } from "@/lib/auth/PublicAuthContext";
import { BookmarkProvider } from "@/lib/bookmarks/BookmarkContext";
import { ReactionsProvider } from "@/lib/reactions/ReactionsContext";
import { TabBreadcrumbProvider } from "@/contexts/TabBreadcrumbContext";
import { DeviceProvider } from "@/contexts/DeviceContext";
import dynamic from "next/dynamic";

const ScrollToTop = dynamic(() => import("@/components/ScrollToTop"), { ssr: false });

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <DeviceProvider>
      <PublicAuthProvider>
        <BookmarkProvider>
          <ReactionsProvider>
            <TabBreadcrumbProvider>
              <ScrollToTop />
              {children}
            </TabBreadcrumbProvider>
          </ReactionsProvider>
        </BookmarkProvider>
      </PublicAuthProvider>
    </DeviceProvider>
  );
}
